
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  props: {
    rel: String as PropType<string>
  }
})
